export const apiHelper = {
    getReservations: (startDate, endDate) => `api/v1/reservations?startTime=${startDate}&endTime=${endDate}`,
    cancelReservation: id => `api/v1/reservations/${id}`,
    getConference: (startDate, endDate) => `api/v1/conference_participant?start=${startDate}&end=${endDate}`,
    getMessageNoti: () => `api/v1/messages/noti`,
    generatePreSignedURL: (recordingid) => `api/public/v1/cloud-records/generate-share-link/${recordingid}`,
}